<template>
  <div style="position: relative; width: 100%">
    <!-- <keep-alive> -->
    <div>
      <component :is="active" transition-mode="out-in"></component>
    </div>
    <!-- </keep-alive> -->
  </div>
</template>

<script>
import { defineAsyncComponent, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { availableCategories, darkCats } from "@/utils/constants";
import { useStore } from "vuex";

const defaultComponent = defineAsyncComponent({
  // The factory function
  loader: async () => import("./DefaultPage"),

  // // A component to use while the async component is loading
  // loadingComponent: LoadingComponent,

  // // A component to use if the load fails
  // errorComponent: ErrorComponent,

  // // Delay before showing the loading component. Default: 200ms.
  // delay: 10,

  // The error component will be displayed if a timeout is
  // provided and exceeded. Default: Infinity.
  timeout: 3000,
  // Defining if component is suspensible. Default: true.
  suspensible: false,

  /**
   *
   * @param {*} error Error message object
   * @param {*} retry A function that indicating whether the async component should retry when the loader promise rejects
   * @param {*} fail  End of failure
   * @param {*} attempts Maximum allowed retries number
   */
  // onError(error, retry, fail, attempts) {
  //   if (error.message.match(/fetch/) && attempts <= 3) {
  //     // retry on fetch errors, 3 max attempts
  //     retry();
  //   } else {
  //     // Note that retry/fail are like resolve/reject of a promise:
  //     // one of them must be called for the error handling to continue.
  //     fail();
  //   }
  // },
});

const worldComponent = defineAsyncComponent(() => import("./WorldPage"));
const sportComponent = defineAsyncComponent(() => import("./SportPage"));
const mediaComponent = defineAsyncComponent(() => import("./MediaPage"));
const scienceComponent = defineAsyncComponent(() => import("./SciencePage"));
const medicineComponent = defineAsyncComponent(() => import("./MedicinePage"));
const uzbekistanComponent = defineAsyncComponent(() =>
  import("./UzbekistanPage")
);
const politicsComponent = defineAsyncComponent(() => import("./PoliticsPage"));
const hiTechComponent = defineAsyncComponent(() => import("./HitechPage"));

const lifeStyleComponent = defineAsyncComponent(() =>
  import("./LifeStylePage")
);
const societyComponent = defineAsyncComponent(() => import("./SocietyPage"));

export default {
  components: {
    feed: defaultComponent,
    world: worldComponent,
    sport: sportComponent,
    media: mediaComponent,
    lifestyle: lifeStyleComponent,
    medicine: medicineComponent,
    uzbekistan: uzbekistanComponent,
    politics: politicsComponent,
    "hi-tech": hiTechComponent,
    science: scienceComponent,
    society: societyComponent,
  },
  setup() {
    const route = useRoute();
    const active = ref("feed");
    const { commit } = useStore();

    watch(
      () => route.params.category,
      async (newCategory) => {
        if (darkCats.includes(newCategory)) commit("handleTheme", "dark");
        if (newCategory !== undefined) {
          if (availableCategories.includes(newCategory)) {
            active.value = newCategory;
          } else {
            active.value = "feed";
          }
        } else {
          active.value = "feed";
        }
      },
      { immediate: true }
    );

    return {
      active,
    };
  },
};
</script>
